import get from 'transmute/get';
import { makeOptionsFromPropertyWithoutBlankOptions } from 'customer-data-property-utils/PropertyValueDisplay';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { getSubscriptionStatusAvatar } from '../formatted/utils';
import UISelect from 'UIComponents/input/UISelect';
import { memo } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputSubscriptionStatus = ({
  autoFocus,
  buttonUse,
  className,
  disabled,
  inputRef,
  onChange,
  property,
  readOnly,
  value
}) => {
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  const statusOptions = makeOptionsFromPropertyWithoutBlankOptions(property).map(option => Object.assign({}, option, {
    avatar: getSubscriptionStatusAvatar(option.value)
  }));
  return /*#__PURE__*/_jsx(UISelect, {
    autoFocus: autoFocus,
    buttonUse: buttonUse,
    className: className,
    disabled: disabled,
    onChange: onChange,
    options: statusOptions,
    readOnly: readOnly !== undefined ? readOnly : get('readOnlyValue', property),
    ref: inputRef,
    value: value
  });
};
PropertyInputSubscriptionStatus.defaultProps = {
  buttonUse: 'form'
};
export default /*#__PURE__*/memo(PropertyInputSubscriptionStatus);